// extracted by mini-css-extract-plugin
module.exports = {"link":"Navigation_link__VoCK3","activeLink":"Navigation_activeLink__37VUe Navigation_link__VoCK3"};